import styled from '@emotion/styled';
import { Stack } from '@ui-components/neo.tax';

export const QuestionSectionWrapper = styled(Stack)({
  width: '100%',
});

export const StyledTooltipContainer = styled.div({
  display: 'inline-flex',
  alignItems: 'center',
  marginLeft: '0.25rem',
});
